module.exports = __webpack_public_path__ + "static/media/sandwich-white.41fe0cc6.png";